// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"236":"8e32a202","710":"6a692ed8"}[chunkId] + ".chunk.css";
};